/**
 * The host the dlvr.it brand SVGs are served from, for components that take an
 * `assetBaseUrl` (`<Networks>`, `SourceMark`, the wizard steps).
 *
 * Derived from the app config rather than hard-coded so dev serves them locally
 * and production serves them from the CDN. Every existing prod call site builds
 * this as `assetsUrl + "/" + imageUrl`, which yields a doubled slash — `imageUrl`
 * is "/dist/img/", already rooted. Harmless in a URL, but the components here
 * append "/svg-logos/…", so the separators are normalised once instead of each
 * call site guessing.
 *
 * Returns e.g. "https://static.dlvrit.com/dist/img", or "/dist/img" in dev
 * where `assetsUrl` is empty.
 */
export function assetBase(config?: {
  assetsUrl?: string
  imageUrl?: string
}): string {
  const host = (config?.assetsUrl ?? "").replace(/\/+$/, "")
  const path = (config?.imageUrl ?? "").replace(/^\/+|\/+$/g, "")
  return path ? `${host}/${path}` : host
}
